import React from "react";
import { Stack } from "@mui/material";
import AvidaBank from "../assets/svgs/banks/avida.svg";
import FacitBank from "../assets/svgs/banks/facit.svg";
import InstaBank from "../assets/svgs/banks/insta.svg";
import LeaBank from "../assets/svgs/banks/lea.svg";
import MorrowBank from "../assets/svgs/banks/morrow.svg";
import NordaxBank from "../assets/svgs/banks/nordax.svg";
import ResursBank from "../assets/svgs/banks/resurs.svg";
import SveaBank from "../assets/svgs/banks/svea.svg";
import MyBank from "../assets/svgs/banks/mybank.svg";
import SantanderBank from "../assets/svgs/banks/santander.svg";
import KraftBank from "../assets/svgs/banks/kraftbank.svg";
import Bank2 from "../assets/svgs/banks/bank2.svg";
import BluestepBankLogo from "../assets/svgs/bluestepbanklogo.svg";
import TfBank from "../assets/svgs/tfbankLogo.svg";

interface PartnerBanksProps {
  selectedBanks?: string[];
}

const PartnerBanks: React.FC<PartnerBanksProps> = ({ selectedBanks }) => {
  const BankLogos = [
    {
      name: "AvidaBank",
      Logo: AvidaBank,
      link: "https://www.avidafinance.com/no/start/",
    },
    { name: "LeaBank", Logo: LeaBank, link: "https://leabank.no/" },
    { name: "InstaBank", Logo: InstaBank, link: "https://instabank.no/" },
    {
      name: "BluestepBank",
      Logo: BluestepBankLogo,
      link: "https://www.bluestep.no/",
    },
    { name: "Bank2", Logo: Bank2, link: "https://bank2.no/" },
    {
      name: "ResursBank",
      Logo: ResursBank,
      link: "https://www.resursbank.no/",
    },
    { name: "MorrowBank", Logo: MorrowBank, link: "https://morrowbank.no/" },
    { name: "FacitBank", Logo: FacitBank, link: "https://facitbank.no/" },
    { name: "SveaBank", Logo: SveaBank, link: "https://www.svea.com/" },
    { name: "NordaxBank", Logo: NordaxBank, link: "https://www.nordax.no/" },
    // { Logo: MyBank, link: "https://mybank.no/" },
    { name: "KraftBank", Logo: KraftBank, link: "https://kraftbank.no/" },
    {
      name: "SantanderBank",
      Logo: SantanderBank,
      link: "https://www.santanderconsumer.no/",
    },
    { name: "TfBank", Logo: TfBank, link: "https://www.tfbank.no/" },
  ];
  const filteredLogos = selectedBanks
    ? BankLogos.filter((bank) => bank.name && selectedBanks.includes(bank.name))
    : BankLogos;
  return (
    <Stack>
      <Stack
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent="center"
        alignItems="center"
        alignContent={{ xs: "center", md: "flex-start" }}
        gap={{ xs: "48px", md: "24px 48px" }}
        alignSelf="stretch"
        flexWrap="wrap"
      >
        {filteredLogos.map(({ Logo, link }, index) => (
          <Stack
            key={index}
            width="145px"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap="10px"
            sx={{
              "& svg": {
                maxHeight: "100%",
                maxWidth: "100%",
              },
            }}
            component="a"
            href={link}
            target="_blank"
          >
            <Logo />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default PartnerBanks;
